<template>
  <img src="../../public/romoni-logo.png" alt="romoni logo" class="logo" style="height: 40px" />
</template>

<script lang="ts" setup></script>
